import { render } from "./IotPlaceDetail.vue?vue&type=template&id=0da7b2c1&scoped=true"
import script from "./IotPlaceDetail.vue?vue&type=script&lang=js"
export * from "./IotPlaceDetail.vue?vue&type=script&lang=js"

import "./IotPlaceDetail.vue?vue&type=style&index=0&id=0da7b2c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da7b2c1"]])

export default __exports__